import { useNavigate, useParams } from 'react-router-dom';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import TableStyle from '../../../ui-component/TableStyle';
import { useState } from 'react';
import { Stack, Container, Typography, Box, Card, Button } from '@mui/material';
import * as React from 'react';
import { useEffect } from 'react';
import DeleteIcon from '@mui/icons-material/Delete';
import MenuItem from '@mui/material/MenuItem';

import { getApi } from 'views/services/api';
import DeleteInvoice from './DeleteInvoice';

// ----------------------------------------------------------------------

//-------------------------------------------------------------------------------------------------

const ShowBill = () => {
  const [billData, setbillData] = useState([]);
  const [id, setId] = useState('');
  const [openDelete, setOpenDelete] = useState(false);
  const [invData , SetInvData ] = useState()

  const params = useParams();
  const reservationId = params.id;
  console.log("reservationId==>",reservationId);
  const navigate = useNavigate();

  const fetchSingleBillData = async () => {
    try {
      const response = await getApi(`api/singleinvoice/view/${reservationId}`);
      response.data.InvoiceData && setbillData((prevBillData) => [...(prevBillData || []), ...response.data.InvoiceData]);
    } catch (error) {
      console.log(error);
    }
  };

  // function for fetching all the contacts data from the db

  const fetchbillData = async () => {
    try {
      const response = await getApi(`api/invoice/view/${reservationId}`);
      setbillData(response?.data?.InvoiceData);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchbillData();
    fetchSingleBillData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleGenerateBill = (billItem) => {
    // console.log(billItem, 'billItem')
    if (billItem.type === "room" ||billItem.type === "food"  ) {
      navigate(`/roombill/view/${billItem._id}`);
    } else {
      navigate(`/singlebill/view/${billItem.reservationId}`);
    }
  };

  const handleOpenDeleteItem = (invData) => {
    SetInvData(invData);
    setOpenDelete(true);
  };
  const handleCloseDeleteItem = () => setOpenDelete(false);

  //---------------------------------------------------------------------
  const columns = [
    {
      field: `invoiceNumber`,
      headerName: 'Invoice Number',
      flex: 1,
      cellClassName: 'name-column--cell name-column--cell--capitalize',
      renderCell: (params) => {
        return (
          <Box>
            <Box onClick={() => handleGenerateBill(params?.row)}>{params.value}</Box>
          </Box>
        );
      }
    },
    {
      field: `name`,
      headerName: 'Name',
      flex: 1,
      cellClassName: ' name-column--cell--capitalize',

      renderCell: (params) => {
        return (
          <Box>
            <Box>{params.value}</Box>
            <div style={{ marginTop: '4px', fontSize: '12px', color: '#777' }}>{params.row.customerPhoneNumber}</div>
          </Box>
        );
      }
    },
    {
      field: 'address',
      headerName: 'Address',
      flex: 1
    },

    {
      field: 'type',
      headerName: 'Invoice Type',
      flex: 1,
      renderCell: (params) => {
        return <Box>{params.row.type ? params.value : 'Food+Room'}</Box>;
      }
    },
    {
      field: 'foodAmount',
      headerName: 'Food Amount',
      flex: 1,
      renderCell: (params) => {
        return (
          <Box>
            {params.row.totalFoodAmount
              ? `Rs ${params.row.totalFoodAmount}`
              : params.row.foodAmount
              ? `Rs ${params.row.foodAmount}`
              : 'N/A'}
          </Box>
        );
      }
    },
    {
      field: 'roomRent',
      headerName: 'Room Amount',
      flex: 1,
      renderCell: (params) => {
        return (
          <Box>
            {params.row.totalRoomAmount ? `Rs ${params.row.totalRoomAmount}` : params.row.roomRent ? `Rs ${params.row.roomRent}` : 'N/A'}
          </Box>
        );
      }
    },
    {
      field: 'advanceAmount',
      headerName: 'Advance Amount',
      flex: 1,
      renderCell: (params) => {
        return (
          <Box>
            {params.row.totalRoomAmount
              ? 'N/A'
              : params.row.advanceAmount
              ? `Rs ${params.row.advanceAmount}`
              : params.row.totalRoomAmount
              ? 'N/A'
              : 'N/A'}
          </Box>
        );
      }
    },
    {
      field: 'discount',
      headerName: 'Discount',
      flex: 1,
      renderCell: (params) => {
        return <Box>{params.value ? `Rs ${params.value}` : ' N/A'}</Box>;
      }
    },
    {
      field: 'totalAmount',
      headerName: 'Total Amount',
      flex: 1,
      renderCell: (params) => {
        return <Box>{params.row.totalAmount ? `Rs ${params.row.totalAmount}` : `Rs ${params.row.totalFoodAndRoomAmount}`}</Box>;
      }
    },

    {
      field: 'action',
      headerName: 'Action',
      flex: 1,

      renderCell: (params) => {
        return (
          <>
            <MenuItem onClick={() => handleOpenDeleteItem(params.row)} sx={{ color: 'red' }} disableRipple>
              <DeleteIcon style={{ marginRight: '8px', color: 'red' }} />
            </MenuItem>
          </>
        );
      }
    }
  ];

  return (
    <>
      <DeleteInvoice open={openDelete} handleClose={handleCloseDeleteItem} invData={invData} />

      <Container>
        <Stack direction="row" alignItems="center" mb={5} justifyContent={'space-between'}>
          <Stack direction="row" alignItems="center" justifyContent={'flex-end'} spacing={2}></Stack>
        </Stack>
        <TableStyle>
          <Box width="100%">
            <Card style={{ height: '600px', paddingTop: '15px' }}>
              <Typography variant="h4" sx={{ margin: '2px 15px' }}>
                Invoices ( {billData?.length || 0} )
              </Typography>
              {billData && (
                <>
                  <DataGrid
                    rows={billData}
                    columns={columns}
                    checkboxSelection
                    getRowId={(row) => row?._id}
                    slots={{ toolbar: GridToolbar }}
                    slotProps={{ toolbar: { showQuickFilter: true } }}
                  />
                </>
              )}
            </Card>
          </Box>
        </TableStyle>
      </Container>
    </>
  );
};

export default ShowBill;
